var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-app-container" },
    [
      _c(
        "div",
        { staticClass: "content ordercall-page" },
        [
          !_vm.load
            ? _c("div", { staticClass: "align-center block double-padded" }, [
                _c(
                  "div",
                  { staticClass: "block empty" },
                  [
                    _c("spinner", {
                      attrs: {
                        "line-fg-color": "#c6e0a7",
                        size: 64,
                        "line-size": 12
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.load
            ? [
                _c("title-component", { attrs: { count: _vm.countAll } }),
                _vm._v(" "),
                _c("div", { staticClass: "block" }, [
                  _c("div", { staticClass: "float-right" }, [
                    _c("ul", { staticClass: "oc-menu-h" }, [
                      _c(
                        "li",
                        [
                          _c("select-on", {
                            attrs: {
                              count: _vm.settings.backend_count,
                              current: _vm.countOnPage
                            },
                            on: {
                              updateCount: function(val) {
                                _vm.bgSpinner = true
                                _vm.countOnPage = val
                                _vm.getOrders()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "float-left" },
                    [
                      _c("toolbar", {
                        attrs: {
                          date: _vm.date,
                          settings: _vm.settings,
                          period: _vm.datePeriod,
                          "count-period": _vm.countPeriod,
                          statusselect: _vm.statusselect
                        },
                        on: {
                          selectStatus: function(status) {
                            _vm.statusselect = status
                          },
                          selectPeriod: function(period) {
                            _vm.datePeriod = period
                          },
                          updateDate: _vm.setDate,
                          update: function() {
                            _vm.bgSpinner = true
                            _vm.getOrders()
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("table-component", {
                  attrs: { orders: _vm.orders, settings: _vm.settings },
                  on: {
                    deleteOrder: function(order) {
                      _vm.deleteDialog.order = order
                      _vm.deleteDialog.status = true
                    },
                    setStatus: _vm.setStatus,
                    openItems: _vm.openItems
                  }
                }),
                _vm._v(" "),
                _c("pagination", {
                  attrs: {
                    "count-all": _vm.count,
                    current: _vm.page,
                    "count-on-page": _vm.countOnPage,
                    url: "#"
                  },
                  on: { update: _vm.setPage }
                }),
                _vm._v(" "),
                !_vm.orders.length
                  ? _c(
                      "div",
                      { staticClass: "align-center block double-padded empty" },
                      [
                        _c("i", { staticClass: "oc-icon16 ico-search" }),
                        _vm._v("Заявок по заданным параметрам не найдено")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("settings-modal", {
                  attrs: { status: false, settings: _vm.settings },
                  on: { save: _vm.saveSettings }
                }),
                _vm._v(" "),
                _c("delete-modal", {
                  attrs: {
                    status: _vm.deleteDialog.status,
                    order: _vm.deleteDialog.order
                  },
                  on: { deleteOrder: _vm.deleteOrder }
                }),
                _vm._v(" "),
                _c("items-modal", {
                  attrs: {
                    "order-id": _vm.items.orderId,
                    items: _vm.items.data,
                    status: false
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.bgSpinner ? _c("background-spinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79b12d5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79b12d5e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/Backend.vue
// module id = 206
// module chunks = 1